import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import React, { Component } from 'react';
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  InputGroup,
  Navbar,
  Row
} from 'react-bootstrap';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { bindActionCreators } from 'redux';
import * as VideosActions from './redux/VideosActions';

class VideosIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
    console.log('Props', props);
  }

  componentWillMount() {
    this.props.find({});
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    let { history, Videos } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Videos'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() => history.push('/admin/videos/create')}
                      >
                        Agregar Video
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Videos.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={Videos.searchData ? Videos.searchData : Videos.data}
                    page={Videos.table.page}
                    sorted={Videos.table.sorted}
                    filtered={Videos.table.filtered}
                    pageSize={Videos.table.pageSize}
                    onSortedChange={change =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={change =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={change =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={change =>
                      _this.props.changeTable('pageSize', change)
                    }
                    filterable
                    columns={[
                      {
                        Header: 'Título',
                        accessor: 'title',
                        minWidth: 120
                      },

                      {
                        Header: 'Actions',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: props => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}

                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/videos/' + props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>
                          </div>
                        )
                      }
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    Videos: state.Videos
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(VideosActions, dispatch);
};

const VideosConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(VideosIndex);

export default VideosConnect;



// WEBPACK FOOTER //
// ./src/views/Videos/VideosIndex.jsx